import React, { useState, useEffect } from 'react';
import {createRoot} from 'react-dom/client';
import axios from "axios";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import allLocales from '@fullcalendar/core/locales-all'
import RequestsHotelsCalendarModal from './RequestsHotelsCalendarModal.jsx'
import Legend from '../common/calendar_assets/Legend.jsx'
import styled from 'styled-components';
import dayjs from 'dayjs';
import { useStorePage } from '../requests_hotels/stores/storePage.js';


export default function RequestsHotelsCalendar() {
	const {
		requestsHotels,
        parameters,
		calendarChange
	} = useStorePage();

	const [recapTableContent, setRecapTableContent] = useState([]);
	const [filesTableContent, setFilesTableContent] = useState([]);
	const [selectedDate, setSelectedDate] = useState(null);
	const [isModalLoading, setIsModalLoading] = useState(true);

	useEffect(() => {
		if(selectedDate == null) return;
		var newDate = new Date(selectedDate);
		newDate.setDate(newDate.getDate() + 1);
		
		Promise.all([
			fetch(ENV.base_lang_url + "myspace/providers//requests_hotels/get_requests_hotels_list?calendar_date=" + new Date(newDate).toISOString().split('T')[0] + '&' + parameters)
		])
		.then(([res]) => {
			return Promise.all([res.json()]) 
		})
		.then(([res]) => {
			setRecapTableContent(res.recap_table_content);
			setFilesTableContent(res.files_table_content);
			setIsModalLoading(false);
		});
	}, [selectedDate]);

	const renderEventContent = (info) => {
		const { event } = info;
		return (
			<div 
				className={event.className}
				style={{
					width: 'min-content',
					borderColor:  event.borderColor,
					backgroundColor: event.backgroundColor,
					padding: 3,
					margin: '0 auto',
					borderRadius: 3
				}}
			>
				<a 
					href="#"
					data-part="+"
					data-target={'providers//requests_hotels/details/' + event.id}
					className="d-block js-nav get_part_link"
				>
					<span className="small">{event.title}</span>		
				</a>			
			</div>
		)
	}
	
	const handleViewRender = (info) => {
		createRoot(document.querySelector('.fc-toolbar-chunk:nth-child(3)')).render(<Legend/>);
		$('.fc-prev-button').css('margin-left', 0);
		calendarChange(info.view);
	}
	
	const handleShowTooltip = (info) => {
		const startDate = dayjs(info.event.start);
		const endDate = dayjs(info.event.end).subtract(1,'day');

		$(info.el).popover({
			title: '<div class="text-white text-center">' + info.event.title + '</div>',
			placement: 'top',
			trigger: 'hover',
			content: '<div class="small text-center"><span class="text-muted small">' + startDate.format('L')+ ' - ' + endDate.format('L') + '</span><br/>' + '</div>',
			container: 'body',
			html: true,
		});
	}
	
	const handleTooltipCustomization = (info) => {
		$('.popover .popover-header').css('background-color', info.event.backgroundColor);
	}
	
	const handleModal = (info) => {
		setIsModalLoading(true);
		setSelectedDate(info.date)
		$('#daily_recap_modal').modal('show');
	}

	const handlePrevDay = () => {
		var date = new Date(selectedDate);
		date.setDate(date.getDate() - 1);
		setSelectedDate(date)
		setIsModalLoading(true);
	}

	const handleNextDay = () => {
		var date = new Date(selectedDate);
		date.setDate(date.getDate() + 1);
		setSelectedDate(date)
		setIsModalLoading(true);
	}

	const handleMonthChange = (info) => {
		calendarChange(info.view);
	}

	return (
		<Wrapper>
			<div id="requests_hotels_calendar">
				<FullCalendar
					themeSystem='bootstrap'
					plugins={[dayGridPlugin, interactionPlugin]}
					initialView='dayGridMonth'
					weekends={true}
					events={requestsHotels}
					eventContent={renderEventContent}
					height={'80vh'}
					headerToolbar={header}
					eventDidMount={handleShowTooltip}
					dateClick={handleModal}
					viewDidMount={handleViewRender}
					eventMouseEnter={handleTooltipCustomization}
					datesSet={handleMonthChange}
					locales={allLocales} 
					locale={ENV.lang.substring(0,2)}
				/>
			</div>

			<RequestsHotelsCalendarModal date={selectedDate} handlePrevDayFunction={handlePrevDay} handleNextDayFunction={handleNextDay} isLoading={isModalLoading} recapContent={recapTableContent} filesContent={filesTableContent}/>
		</Wrapper>
	)
}

const Wrapper = styled.div`
	#requests_hotels_calendar {
		margin-bottom: 0;
		h2 {
			display: block;
			margin: 0 0 1rem 0;
		}
		.fc-toolbar {
			padding-bottom: 0 !important;
			.fc-toolbar-chunk {
				display: inline-block;
			}
		}
		.fc-view-harness {
			position: relative;
		}
		.fc-view-harness.fc-view-harness-active {
			background-color: #fff; 
		}
		.fc-scrollgrid-sync-table {
			background-color: #fff; 
		}
		.fc-daygrid-event-harness {
			padding: 2px;
			overflow: hidden;
		}
		.btn.btn-primary {
			background-color: #fff;
			color: #000;
			font-size: .9rem;
			border: 1px solid #dfdfdf!important;
		}
		.fc-button-primary {
			background-color: #fff!important;
			color: #000!important;
			border: 1px solid rgb(223, 223, 223) !important;
		}
		.fc-scrollgrid-section-liquid td:first-child .fc-scroller-harness > .fc-scroller {
			overflow-y: scroll !important;
		}

		/* CALENDAR HEADER */
		.fc-header-toolbar {
			padding: 0 0 10px 0;
			margin: 0;

			.fc-toolbar-chunk .btn-group {
				margin-left: 0;
			}
			.fc-toolbar-title {
				color: #004753;
				font-size: 1.4rem;
				font-weight: 500;
				text-transform: capitalize;
				margin-bottom: 10px;
			}
		}
		.fc-col-header {
			height: 40px;
			line-height: 40px;
		}

		/* CALENDAR EVENTS */
		.fc-event-title {
			font-size: .8rem;
			line-height: 20px;
			text-transform: capitalize;
		}
		.fc-event-title-container {
			text-align: center;
		}
		.fc-daygrid-event.fc-daygrid-block-event.fc-h-event.fc-event.fc-event-start.fc-event-end {
			transition: .3s;
		}
		.fc-daygrid-event {
			border: none !important;
			:hover {
				opacity: .7;
			}
			&.fc-event-end {
				&.event-mid-day {
					width: calc(100% - 9rem);
				}        
			}
		}
		@media only screen and (max-width: 1400px) {
			.fc-daygrid-event {
				&.fc-event-end {
					&.event-mid-day {
						width: calc(100% - 8rem);
					}        
				}
			}
		}
		@media only screen and (max-width: 1000px) {
			.fc-daygrid-event {
				&.fc-event-end {
					&.event-mid-day {
						width: calc(100% - 6rem);
					}        
				}
			}
		}
		@media only screen and (max-width: 800px) {
			.fc-daygrid-event {
				&.fc-event-end {
					&.event-mid-day {
						width: calc(100% - 4rem);
					}        
				}
			}
		}
		@media only screen and (max-width: 600px) {
			.fc-daygrid-event {
				&.fc-event-end {
					&.event-mid-day {
						width: calc(100% - 2rem);
					}        
				}
			}
		}

		/* CALENDAR DATE CELL */
		.fc-daygrid-day .fc-day:hover {
			opacity: .7!important;
		}
		.fc-col-header-cell-cushion {
			text-transform: capitalize;	
		}

		/* CALENDAR DAY GRID */
		.fc-day:not(:last-child) {
			border-right: solid 2px #83a3a9bf !important;
		}
		.fc-daygrid-day {
			cursor: pointer;
		}
		.fc-daygrid-day-top {
			text-align: center;

			.fc-daygrid-day-number {
				font-size: .9rem;
				font-weight: 400;
				display: block;
				height: 30px;
				width: 30px;
				border: 1px solid #ddd;
				border-radius: 50px;
				padding-top: 3px;
				margin: auto;
				margin-top: 5px;
				transition: .3s;
			}
		}
		.fc-daygrid-day-frame {
			border-bottom: solid 2px #F0F0F0 !important;
		}
		.fc-daygrid-day-frame:hover .fc-daygrid-day-number {
			background-color: #F26721;
			color: #fff;
		}
		.fc .fc-daygrid-day.fc-day-today,
		.fc-daygrid-day .fc-day .fc-day-tue .fc-day-today {
			background-color: #fff!important;
			background-color: rgba(0,0,0,0)!important;
		}
		.fc-day-today .fc-daygrid-day-number {
			background-color: #f26721;
			color: #fff;
		}

		/* CALENDAR LIST VIEW */ 
		.fc-list-event-time {
			display: none;
		}
		.fc-list-event-title {
			text-transform: capitalize;
		}
	}

	.fc-license-message {
		display: none;
	}

	@media only screen and (max-width: 700px) {
		.fc .fc-toolbar {
			display: block!important;
		}
	}
`;

const header = {
	left: "title prev next today",
	center: "",
	right: ""
}